import React from 'react';
import './Photos.scss';

function InlinePhoto({ photoContents, photoRef, photoSize }) {
  return (
    <section
      className={
        photoSize === 'fullBleed' ? 'inline inline--fullbleed' : 'inline inline--contentWidth'
      }
    >
      <div
        ref={photoRef}
        role="img"
        aria-label={photoContents.description || photoContents.caption}
        className={
          photoSize === 'fullBleed'
            ? `inline__background inline__background--fullbleed inline--${photoContents.class} `
            : `inline__background inline__background--contentWidth inline--${photoContents.class} `
        }
      />
      {photoContents.caption ? (
        <div className="inline__caption">
          <p className="inline__caption__text">{photoContents.caption}</p>
        </div>
      ) : (
        <></>
      )}
    </section>
  );
}

export default InlinePhoto;
